"use strict";

import { addExportBtns, addSearchColumn, addFormControlSelect2 } from "../jquery-functions-library";
import { element_exists, redesignDataTablesHeader } from "../functions";
import { filter } from "lodash";

var activitiesTable = null;
var selectedRows = []; // Array to store selected rows
var filterTableNames = [];

export var fnActivitiesTable = function() {
    const APPLY_FILTER_BUTTON = $("#apply-filter-button");
    const TABLE_CONTAINER = $(".activities-table-container");
    const DATABLE_ACTIVITIES = $("#datatable-activities");
    const EXPANDABLE_CONTAINER = $(".expand-collapse-container");

    let $customerSelector = $('#customer-filter-selector');
    $customerSelector.select2();
    addFormControlSelect2();

    APPLY_FILTER_BUTTON.on("click", function() {
      let fromDate = $("#from-date").val();
      let toDate = $("#to-date").val();

      TABLE_CONTAINER.removeClass('hidden');
      DATABLE_ACTIVITIES.removeClass('hidden');
      EXPANDABLE_CONTAINER.removeClass('hidden');

      loadTable(fromDate, toDate);
    });
};

function loadTable(fromDate, toDate) {
  var tableName = "#datatable-activities";

  if (activitiesTable) {
    activitiesTable.destroy();
  }

  $.fn.dataTable.moment("DD/MM/YYYY HH:mm");

  var columns = [
    { data: "id" },
    { data: "by" },
    { data: "description"},
    { data: "action" },
    { data: "for" },
    {
      data: "content",
      render(data) {
        let json = data ? data : null;

        if (json) {
          json = json.replaceAll(/&quot;/g, '"');
          json = JSON.parse(json);
          let content = "";
          Object.keys(json).forEach(function(key) {
            if (typeof json[key] === "object") {
              return;
            }
            content += `<b>${key}:</b> ${json[key]}<br>`;
          });

          return content;
        } else {
          return "";
        }
      },
    },
    { data: "created_column" }
  ];

  /*Rules for filling the columns*/
  var columnDefs = [
    { visible: false, targets: 0,
      searchPanes: {
        show: false,
      },
      orderable: false, 
    },
    { visible: true, targets: 1, 
      searchPanes: {
        show: false,
      },
      orderable: false,
     },
    { visible: true, targets: 2, width: "20%",
      searchPanes: {
        show: false,
      },
      orderable: false,
 
    },
    { visible: true, targets: 3, 
      searchPanes: {
        show: false,
      },
      orderable: false,
    },
    { visible: true, 
      targets: 4,
      searchPanes: {
      show: false,
      },
      orderable: false, 
    },
    {
      visible: true,
      targets: 5,
      searchPanes: {
        show: false,
      },
      orderable: false,
    },
    {
      visible: true,
      targets: 6,
      searchPanes: {
        show: false,
      },
      orderable: false,

    },
  ];

  /*Important otherwise table misaligned*/
  $(tableName).css("width", "100%");

  var table = $(tableName).DataTable({
    language: allLangFiles.datatables,
    rowId: "id",
    ajax: {
      url: '/activities/load-table',
      method: 'GET',
      data: {
        selectedRows: selectedRows,
        fromDate: fromDate,
        toDate: toDate,
      },
      dataSrc: function(json) {
        return json.data;
      },
    },
    searchPane: false,
    searching: false,
    columns: columns,
    columnDefs: columnDefs,
    lengthMenu: [[-1, 10, 25, 50, 75, 100], [allLangFiles.datatables.all, 10, 25, 50, 75, 100]],
    pageLength: 10,
    serverSide: true,
  });

  activitiesTable = table; // Assign DataTable instance to activitiesTable variable

  addSearchColumn(tableName, table);
  addExportBtns($(tableName));
  filterTables(fromDate, toDate);
  redesignDataTablesHeader(tableName, false, null, false);

  var searchIcon = document.querySelector('.datatables_search-icon');
  if (searchIcon) {
    searchIcon.remove();
  }

}

// Function to populate the filter tables
function filterTables(fromDate, toDate) {
  $.ajax({
    url: '/activities/load-activities',
    method: 'GET',
    data: {
      selectedRows: selectedRows,
      fromDate: fromDate,
      toDate: toDate,
    },
    success: function(responseData) {
      // Iterate over the filter tables and populate each one
      for (var key in allLangFiles.activities.filterTable) {
        var filterTableName = '#filter-table-' + key;
        var tableData = responseData[key];

        if (!filterTableNames.includes(filterTableName)) {
          // Call the populateFilterTable function to fill the DataTable with data
          populateDataTable(filterTableName, tableData, key, fromDate, toDate);
          filterTableNames.push(filterTableName);
        }else{
          modifyFilters(filterTableName, tableData, key);
        }
      }
    },
    error: function(xhr, status, error) {
      console.error('Error:', error);
    }
  });  
};


function populateDataTable(filterTableName, data, key, fromDate, toDate) {
  $(document).ready(function() {
    var events = $('#events');
    var filterTable = $(filterTableName).DataTable({
      language: allLangFiles.datatables,
      searchPane: false,
      searching: true,
      paging: false,
      info: false,
      fixedHeader: true,
      scrollY: '200px',
      scrollX: true,
      scrollCollapse: true,
      select: true,
      autoHeight: true,
      deferRender: true,
      columnDefs: [
        { 
          width: '85%',
          targets: 0, 
          render: function ( data, type, row ) {
            return data.substr( 0, 40 ) + (data.length > 40 ? '...' : '' );
          } 
        },
        { width: '15%', targets: 1 }
      ],
      order: [[1, 'desc']],
    });

    var filterHeader = $('<div>').addClass('filter-header');
    var collapseButton = $('<button>').attr('id', 'btn-show-filter').attr('type', 'button').addClass('collapse-button');
    var arrowIcon = $('<i>').addClass('arrow up');
    
    collapseButton.append(arrowIcon);
    filterHeader.append(collapseButton);

    // Modify the CSS for the filter table
    $(filterTableName).addClass('no-horizontal-scroll');
    $(filterTableName).addClass('no-scroll-bar');

    $('#filter-table-' + key + '_filter').after(filterHeader);
    
    // Add click event handler to the collapse button
    collapseButton.on('click', function() {
      var tableBody = $('#filter-table-' + key);
      var tableContainer = tableBody.closest('.table-container');
      
      tableBody.toggle();
      arrowIcon.toggleClass('up down'); // Toggle the arrow icon class
      
      // Adjust the arrow icon based on the table body visibility
      if (tableBody.is(':visible')) {
        arrowIcon.removeClass('down').addClass('up');
        tableContainer.css('height', 'auto');
      } else {
        arrowIcon.removeClass('up').addClass('down');
        tableContainer.css('height', '110px');
      }
    });

    var collapseFilterButton = $(".collapse-filter-button");
    var expandFilterButton = $(".expand-filter-button");

    collapseFilterButton.on('click', function() {
      const keys = ['for', 'by', 'description', 'action'];

      keys.forEach(function(key) {
        var tableBody = $('#filter-table-' + key);
        var tableContainer = tableBody.closest('.table-container');

        tableBody.toggleOff();
        if (tableBody.is(':visible')) {
          arrowIcon.removeClass('down').addClass('up');
          tableContainer.css('height', 'auto');
        } else {
          arrowIcon.removeClass('up').addClass('down');
          tableContainer.css('height', '110px');
        }
      })
      
    });
    
    // Add click event handler to the expand button
    expandFilterButton.on('click', function() {
      const keys = ['for', 'by', 'description', 'action'];
    
      keys.forEach(function(keyword) {
        var tableBody = $('#filter-table-' + keyword);
        var tableContainer = tableBody.closest('.table-container');

        tableBody.show();
        if (tableBody.is(':visible')) {
          arrowIcon.removeClass('down').addClass('up');
          tableContainer.css('height', 'auto');
        } else {
          arrowIcon.removeClass('up').addClass('down');
          tableContainer.css('height', '110px');
        }
      });
    });

    filterTable
      .on('select', function (e, dt, type, indexes) {
        var selectedData = filterTable.rows(indexes).data().toArray();
        selectedData.forEach(function (row) {
          row.push(key); // Add the "key" to the row data
        });
        selectedRows.push(...selectedData); // Add selected rows to the array
        loadTable(fromDate, toDate);
      })
      .on('deselect', function (e, dt, type, indexes) {
        var deselectedData = filterTable.rows(indexes).data().toArray();
        deselectedData.forEach(function (row) {
          var index = selectedRows.findIndex(function (selectedRow) {
            return selectedRow[0] === row[0] && selectedRow[1] === row[1];
          });
          if (index !== -1) {
            selectedRows.splice(index, 1); // Remove deselected row from the array
          }
        });
        loadTable(fromDate, toDate);
      });

    // Add the name and count as a single row to the DataTable
    for (const property in data) {
      const name = property;
      const count = data[property];
      const rowData = [name, count];
      filterTable.row.add(rowData);
    }

    /*Important otherwise table misaligned*/
    $(filterTableName).css("height", "200px");

    // Draw the updated DataTable
    filterTable.draw();
  });
}

function modifyFilters(filterTableName, tableData, key) {
  $(document).ready(function() {
    var filterTable = $(filterTableName).DataTable();

    // Get the current filter names
    var currentFilters = filterTable
      .rows()
      .data()
      .toArray()
      .map(function(rowData) {
        return rowData[0];
      });

    // Update counts for existing filters and add new filters
    for (const property in tableData) {
      const filterName = property;
      const count = tableData[property];

      var existingRow = filterTable
        .rows()
        .indexes()
        .filter(function(idx) {
          var rowData = filterTable.row(idx).data();
          return rowData && rowData.length > 0 && rowData[0] === filterName;
        });

      if (existingRow.length > 0) {
        var existingRowIndex = existingRow[0];
        var existingRowData = filterTable.row(existingRowIndex).data();
        existingRowData[1] = count;
        filterTable.row(existingRowIndex).data(existingRowData);
      } else {
        filterTable.row.add([filterName, count]);
      }
    }

    // Update counts for filters with 0 count
    currentFilters.forEach(function(filterName) {
      if (tableData === undefined || !(filterName in tableData)) {
        var existingRow = filterTable
          .rows()
          .indexes()
          .filter(function(idx) {
            var rowData = filterTable.row(idx).data();
            return rowData && rowData.length > 0 && rowData[0] === filterName;
          });

        if (existingRow.length > 0) {
          var existingRowIndex = existingRow[0];
          var existingRowData = filterTable.row(existingRowIndex).data();
          existingRowData[1] = 0;
          filterTable.row(existingRowIndex).data(existingRowData);
        }
      }
    });

    // Redraw the DataTable to display the updated data
    filterTable.draw();
  });
}

$.fn.toggleOff = function() {
  return this.each(function() {
    $(this).hide(); // Hide the element
  });
};